import React from 'react';
import styled from 'styled-components';
import { CardSubhead, CardTitle } from '@spark/ui-components/components/Card';
import { ButtonWithLoading } from '@spark/ui-components/components/Button';

const OuvidoriaHeader = ({ totalRegistros, onAdicionar }) => (
  <HeaderWrap>
    <div>
      <CardTitle>Ouvidoria</CardTitle>
      <CardSubhead>Total de registros: {totalRegistros}</CardSubhead>
    </div>

    {/* Removido devido a regra de negócio */}
    {/*     
    {onAdicionar && (
      <ButtonContainer>
        <ButtonWithLoading variant="primary" onClick={onAdicionar}>
          Adicionar
        </ButtonWithLoading>
      </ButtonContainer>
    )} */
    }
  </HeaderWrap>
);

export default OuvidoriaHeader;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
`;
